import React, { FC } from 'react';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Helper from '../../../../../utils/helper';
import TimeHelper from '../../../../../utils/time';
import { openExternalLink, shouldShowReturnInvoiceLink } from '../../RefundV2.helpers';

type RefundV2PaymentInfoCardProps = {
    paymentListInfo: any;
    getRefundDetails: any;
    payBackListInfo: any;
    customerId: any;
    orderId: any;
    otherLink: string;
    onExpenseBillClick: () => void;
};

export const RefundV2PaymentInfoCard: FC<RefundV2PaymentInfoCardProps> = ({
    paymentListInfo,
    getRefundDetails,
    payBackListInfo,
    customerId,
    orderId,
    otherLink,
    onExpenseBillClick,
}) => {
    const { t } = useTranslation();

    if (!paymentListInfo || !getRefundDetails) {
        return null;
    }

    return (
        <Card style={{ height: '30rem' }}>
            <CardHeader
                title={
                    <Typography noWrap gutterBottom variant="h6" component="h4">
                        <b>{t('refund.paymentInfo')}</b>
                    </Typography>
                }
            />
            <Divider />
            <CardContent>
                <p>
                    <b>{t('refund.refundReason')}: </b>
                    {Helper.getRefundReasonName(getRefundDetails.entity.refundReasonId)}
                </p>
                <p>
                    <b>{t('return.returnId')}: </b>
                    {getRefundDetails?.entity?.returnId && getRefundDetails.entity.returnId !== 0 ? (
                        <label
                            className="linktxt"
                            onClick={() => {
                                openExternalLink(
                                    `${otherLink}/returnDetail/?ReturnId=${getRefundDetails.entity.returnId}&customerId=${customerId}`
                                );
                            }}
                        >
                            {getRefundDetails.entity.returnId}
                        </label>
                    ) : (
                        '-'
                    )}
                </p>
                <p>
                    <b>{t('refund.orderId')}: </b>
                    {orderId && orderId !== 0 ? (
                        <label
                            className="linktxt"
                            onClick={() => {
                                openExternalLink(`${otherLink}/orderdetail?orderId=${orderId}`, '_blank');
                            }}
                        >
                            {orderId}
                        </label>
                    ) : (
                        '-'
                    )}
                </p>
                <p>
                    <b>{t('refund.paymentStatus')}: </b>
                    {Helper.getRefundStatusName(getRefundDetails.entity.refundStatusId)}{' '}
                </p>
                {customerId && payBackListInfo && payBackListInfo?.items?.length > 0 && (
                    <p>
                        <b>{t('refund.refundFulfillDate')}:</b>{' '}
                        {TimeHelper.formatDateHour(payBackListInfo?.items[0]?.updateDate)}
                    </p>
                )}
                {shouldShowReturnInvoiceLink(getRefundDetails) && (
                    <p>
                        <b>{t('refund.returnInvoice')}: </b>
                        <label className="linktxt" onClick={onExpenseBillClick}>
                            EX {getRefundDetails?.entity.refundId}
                        </label>
                    </p>
                )}
            </CardContent>
        </Card>
    );
};
